// IMPORTANT Autogenerated file
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
// eslint-disable-next-line @nrwl/nx/enforce-module-boundaries
import { BaseCRUDApiClient } from '@ideapa/app-base-api-client';
import {
  RiduzioneProporzionaleDto,
  RiduzioneProporzionaleRigaDto,
} from '@ideapa/common-dto';

import { ApiClientConfig } from '../api-client-config';

@Injectable()
export class RiduzioneProporzionaleApiClient extends BaseCRUDApiClient<RiduzioneProporzionaleDto> {
  baseUrl = this.config.apiEndpoint + '/riduzione-proporzionale';

  constructor(http: HttpClient, private config: ApiClientConfig) {
    super(http);
  }

  calcolaRiduzioni() {
    this._pagedCache.clear();
    return this.http.get<RiduzioneProporzionaleDto[]>(
      this.baseUrl + '/calcola-riduzioni'
    );
  }

  updateRiduzione(
    idRiduzione: number,
    idPartecipataEnte: number,
    riga: Partial<RiduzioneProporzionaleRigaDto>,
    riduzioneProporzionale: number
  ) {
    this._pagedCache.clear();
    return this.http.post<RiduzioneProporzionaleDto>(
      this.baseUrl + '/update-riduzione',
      {
        idRiduzione: idRiduzione,
        idPartecipataEnte: idPartecipataEnte,
        riga: riga,
        riduzioneProporzionale: riduzioneProporzionale,
      }
    );
  }

  hasRiduzioni() {
    this._pagedCache.clear();
    return this.http.get<boolean>(this.baseUrl + '/has-riduzioni');
  }
}
